import { LAYOUTS, POSITION } from "@voltmoney/types";
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { Platform } from "react-native";
import { ACTION } from "./types";
import { closePopup, editSliderAmount, goBack, goConfirmPledge, goToEditPortFolio, needHelp, OnChangeCompleteSlider, OnChangeSlider } from "./action";
import { addCommasToNumber, getBackgroundColor, getMinAllowedAmountBasedOnLender, roundDownToNearestHundred, getParameters, allowDynamicLimitFromBE } from "../../../configs/utils";
import SharedPropsService from "../../../SharedPropsService";
import sharedPropsService from "../../../SharedPropsService";
import { fetchPledgeLimitRepo } from "../unlock_limit/repo";
import { portfolioListDatastoreBuilderSetCreditLimit } from "./utils";
import { getDesiredValue } from "../portfolio_readonly/actions";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { MIN_LIMIT } from "../../../configs/constants";
import { getTotalLimit } from "../portfolio_V2/actions";
import { isDarkModeTheme } from "../../../configs/config";
let isDarkMode = isDarkModeTheme();
export const template = async (maxAmount, stepResponseObject, updateAvailableCASMap, portValue, lenderId, isEnhancedLimit, totalCreditAmount, isMyFi, minimumAmount, isEligible, allowDynamicLimitFromBEFlag, isNotEligible, isFromMFCentral) => ({
    layout: {
        id: ROUTE.SET_CREDIT_LIMIT,
        type: LAYOUTS.LIST,
        widgets: [
            {
                id: "customHeader",
                type: WIDGET.CUSTOM_HEADER,
                position: POSITION.ABSOLUTE_TOP,
            },
            {
                id: "amountStack",
                type: WIDGET.STACK,
            },
            { id: "spaceSize6", type: WIDGET.SPACE },
            { id: "slider", type: WIDGET.SLIDER },
            { id: "space3", type: WIDGET.SPACE },
            { id: "minMaxStack", type: WIDGET.STACK },
            { id: "space4", type: WIDGET.SPACE },
            {
                id: "bottomCard",
                type: WIDGET.CARD,
                padding: {
                    horizontal: -16,
                    vertical: 0,
                },
            },
            {
                id: 'bottomCardDivider',
                type: WIDGET.DIVIDER,
                position: POSITION.ABSOLUTE_BOTTOM,
                padding: {
                    horizontal: -16
                }
            },
            {
                id: 'bottomCardStack',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_BOTTOM,
            },
        ],
    },
    datastore: {
        bottomCardDivider: {
            size: DividerSizeTokens.MD,
            color: ColorTokens.Grey_Milk_1
        },
        bottomCardStack: {
            width: StackWidth.FULL,
            padding: {
                top: SizeTypeTokens.XL,
            },
            widgetItems: [
                {
                    id: "ctaButton",
                    type: WIDGET.BUTTON
                },
            ]
        },
        amountStack: {
            width: StackWidth.FULL,
            type: StackType.column,
            isDarkMode: true,
            alignItems: StackAlignItems.center,
            padding: {
                horizontal: SizeTypeTokens.NONE,
                vertical: SizeTypeTokens.NONE,
            },
            widgetItems: [
                { id: "space0", type: WIDGET.SPACE },
                { id: "selectText", type: WIDGET.TEXT },
            ],
        },
        customHeader: {
            title: "Set credit limit",
            needHelpAction: {
                routeId: ROUTE.SET_CREDIT_LIMIT,
                type: ACTION.NEED_HELP,
                payload: { id: 'bt_setCreditLimit_needHelp' }
            },
            isDarkMode: isDarkMode ? true : false,
            goBackAction: {
                routeId: ROUTE.SET_CREDIT_LIMIT,
                type: ACTION.GO_BACK,
                payload: { id: 'bt_setCreditLimit_goBack', isFromMFCentral: isFromMFCentral }
            },
        },
        space0: {
            size: SizeTypeTokens.Size32,
        },
        selectText: {
            label: "Select the amount",
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: "500",
            fontSize: FontSizeTokens.MD,
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
        },
        space2: {
            size: SizeTypeTokens.XXXXXL,
        },
        slider: {
            value: await SharedPropsService?.getCreditLimit(),
            minimumValue: allowDynamicLimitFromBEFlag
                ? minimumAmount
                : isEnhancedLimit
                    ? MIN_LIMIT.ENHANCE_LIMIT
                    : getMinAllowedAmountBasedOnLender(lenderId),
            maximumValue: maxAmount,
            showSlider: !isMyFi,
            step: maxAmount < 25000 ? 100 : 1000,
            isDarkMode: isDarkMode ? true : false,
            paddingHorizontal: 10,
            onValueChangeAction: {
                type: ACTION.ON_CHANGE_SLIDER,
                routeId: ROUTE.SET_CREDIT_LIMIT,
                payload: {
                    stepResponseObject: stepResponseObject,
                },
            },
            action: {
                type: ACTION.ON_CHANGE_COMPLETE_SLIDER,
                routeId: ROUTE.SET_CREDIT_LIMIT,
                payload: {
                    stepResponseObject: stepResponseObject,
                },
            },
            onEditIconClickAction: {
                type: ACTION.EDIT_LIMIT,
                routeId: ROUTE.SET_CREDIT_LIMIT,
                payload: {
                    maxAmount,
                    stepResponseObject,
                    updateAvailableCASMap,
                },
            }
        },
        space3: {
            size: SizeTypeTokens.XXL,
        },
        minMaxStack: {
            width: StackWidth.FULL,
            type: StackType.row,
            justifyContent: StackJustifyContent.spaceBetween,
            padding: {
                horizontal: SizeTypeTokens.NONE,
                vertical: SizeTypeTokens.NONE,
            },
            widgetItems: [
                { id: "minText", type: WIDGET.TEXT },
                { id: "maxText", type: WIDGET.TEXT },
            ],
        },
        minText: {
            label: allowDynamicLimitFromBEFlag
                ? `Min ₹${addCommasToNumber(minimumAmount)}`
                : `Min ₹${isEnhancedLimit ? addCommasToNumber(MIN_LIMIT.ENHANCE_LIMIT) : addCommasToNumber(getMinAllowedAmountBasedOnLender(lenderId))}`,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
            fontSize: FontSizeTokens.XS,
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
        },
        maxText: {
            label: `Max ₹${addCommasToNumber(maxAmount)}`,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
            fontSize: FontSizeTokens.XS,
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
        },
        space4: {
            size: SizeTypeTokens.Size32,
        },
        bottomCard: {
            bgColor: isDarkMode ? ColorTokens.DARK_MODE : ColorTokens.White,
            borderTopLeftRadius: BorderRadiusTokens.BR4,
            borderTopRightRadius: BorderRadiusTokens.BR4,
            borderBottomLeftRadius: BorderRadiusTokens.BR0,
            borderBottomRightRadius: BorderRadiusTokens.BR0,
            // border: SizeTypeTokens.LG,
            body: {
                widgetItems: [
                    { id: "bottomSpace11", type: WIDGET.SPACE },
                    {
                        id: "bottomSheetStack",
                        type: WIDGET.STACK,
                    },
                    { id: "space11", type: WIDGET.SPACE },
                    {
                        id: "bottomSheetStack2",
                        type: WIDGET.STACK,
                    },
                    { id: "infoSpace", type: WIDGET.SPACE },
                    { id: "infoRow", type: WIDGET.STACK },
                    { id: "infoSpace2", type: WIDGET.SPACE },
                    { id: "divider0", type: WIDGET.DIVIDER },
                    { id: "listItem", type: WIDGET.LIST },
                ],
            },
        },
        bottomSheetStack: {
            type: StackType.row,
            justifyContent: StackJustifyContent.spaceBetween,
            alignItems: StackAlignItems.center,
            padding: {
                horizontal: SizeTypeTokens.XS,
                vertical: SizeTypeTokens.XS,
            },
            widgetItems: [
                { id: "bottomSheetText", type: WIDGET.TEXT },
                { id: "editText", type: WIDGET.BUTTON },
            ],
        },
        bottomSheetText: {
            label: "Selected mutual funds",
            fontWeight: "600",
            fontSize: FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Poppins,
            lineHeight: 24,
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
        },
        editText: {
            id: 'bt_setCreditLimit_editSelection',
            label: "Edit selection",
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "600",
            type: ButtonTypeTokens.MediumGhost,
            paddingHorizontal: SizeTypeTokens.MD,
            paddingVertical: SizeTypeTokens.MD,
            action: {
                type: ACTION.EDIT_PORTFOLIO,
                payload: {
                    stepResponseObject: stepResponseObject,
                    updateAvailableCASMap: updateAvailableCASMap,
                },
                routeId: ROUTE.SET_CREDIT_LIMIT,
            },
        },
        mfStack: {
            width: StackWidth.FULL,
            type: StackType.row,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: "mfText", type: WIDGET.TEXT },
                { id: "mfText2", type: WIDGET.TEXT },
            ],
        },
        mfText: {
            label: `Mutual fund`,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "500",
            fontSize: FontSizeTokens.XS,
            color: ColorTokens.Grey_Charcoal,
        },
        mfText2: {
            label: isEnhancedLimit ? 'Additional credit limit' : 'Available credit limit',
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "500",
            fontSize: FontSizeTokens.XS,
            color: ColorTokens.Grey_Charcoal,
        },
        bottomSpace11: {
            size: SizeTypeTokens.XXXXL,
        },
        space11: {
            size: SizeTypeTokens.MD,
        },
        space12: {
            size: SizeTypeTokens.XL,
        },
        space13: {
            size: SizeTypeTokens.Size10,
        },
        spaceSize6: {
            size: SizeTypeTokens.XL
        },
        divider: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Grey_Milk_1,
        },
        bottomSheetStack2: {
            type: StackType.row,
            justifyContent: StackJustifyContent.spaceBetween,
            alignItems: StackAlignItems.center,
            padding: {
                horizontal: SizeTypeTokens.XS,
                vertical: SizeTypeTokens.XS,
            },
            widgetItems: [
                // { id: "leftSpace", type: WIDGET.SPACE },
                { id: "bottomSheetText2", type: WIDGET.TEXT },
            ],
        },
        bottomSheetText2: {
            label: `₹${addCommasToNumber(portValue)} out of ₹${addCommasToNumber(parseInt(stepResponseObject["totalPortfolioAmount"].toString()))} are selected for pledging.`,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
            fontSize: FontSizeTokens.SM,
            color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_Charcoal,
            lineHeight: 24,
        },
        space5: {
            size: SizeTypeTokens.MD,
        },
        infoSpace: {
            size: SizeTypeTokens.XL,
        },
        infoSpace2: {
            size: SizeTypeTokens.MD,
        },
        divider0: {
            size: DividerSizeTokens.MD,
            type: "solid",
            color: ColorTokens.Grey_Milk_1,
        },
        infoRow: {
            type: StackType.row,
            width: StackWidth.FULL,
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: "col1Headers", type: WIDGET.STACK },
                { id: "col2Headers", type: WIDGET.STACK },
            ],
        },
        col1Headers: {
            type: "row",
            justifyContent: StackJustifyContent.flexStart,
            alignItems: StackAlignItems.flexStart,
            width: StackWidth.CONTENT,
            widgetItems: [
                { id: "col1Header", type: WIDGET.TEXT },
                { id: "col1Space", type: WIDGET.SPACE },
            ],
        },
        col2Headers: {
            type: "row",
            justifyContent: StackJustifyContent.flexEnd,
            alignItems: StackAlignItems.flexEnd,
            width: StackWidth.CONTENT,
            widgetItems: [
                { id: "col2Header", type: WIDGET.TEXT },
                // { id:"col2Space", type: WIDGET.SPACE },
            ],
        },
        col1Space: {
            size: SizeTypeTokens.XXXL,
        },
        col2Space: {
            size: SizeTypeTokens.XXXL,
        },
        col1Header: {
            label: "Mutual fund",
            fontSize: FontSizeTokens.XS,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "500",
            color: ColorTokens.Grey_Charcoal,
            lineHeight: 18,
        },
        col2Header: {
            label: "Available Credit limit",
            fontSize: FontSizeTokens.XS,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "500",
            color: ColorTokens.Grey_Charcoal,
            lineHeight: 18,
        },
        bottomStackText: {
            label: `₹${addCommasToNumber(await SharedPropsService.getDesiredPortfolio())} out of ₹${addCommasToNumber(parseInt(stepResponseObject["totalPortfolioAmount"].toString()))} are selected for pledging.`,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Charcoal,
        },
        space6: {
            size: SizeTypeTokens.MD,
        },
        ...(await portfolioListDatastoreBuilderSetCreditLimit(stepResponseObject)),
        ctaButtonStack: {
            type: StackType.column,
            widgetItems: [
                { id: "infoSpace", type: WIDGET.SPACE },
                { id: "ctaButton", type: WIDGET.BUTTON }
            ]
        },
        ctaButton: {
            id: 'bt_setCreditLimit_confirmAmount',
            label: "Confirm limit and proceed",
            fontWeight: "700",
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            type: isNotEligible
                ? ButtonTypeTokens.LargeOutline
                : ButtonTypeTokens.LargeFilled,
            width: ButtonWidthTypeToken.FULL,
            action: {
                type: ACTION.GO_CONFIRM_PLEDGE,
                routeId: ROUTE.SET_CREDIT_LIMIT,
                payload: {
                    stepResponseObject: stepResponseObject,
                },
            },
        },
    },
});
export const setCreditLimitMf = {
    bgColor: `#${getBackgroundColor()}`,
    onLoad: async ({ instrumentTrack }, { isFromMFCentral }) => {
        const authCAS = await SharedPropsService.getAuthCASResponse();
        const totalCreditAmount = roundDownToNearestHundred(getTotalLimit(
        //@ts-ignore
        authCAS.stepResponseObject.availableCAS, authCAS.stepResponseObject.isinNAVMap, authCAS.stepResponseObject.isinLTVMap));
        let isFromMyFi = false;
        if (Platform.OS === 'web') {
            let params = getParameters(window?.location?.href);
            if (params?.platform === "MYFI") {
                isFromMyFi = true;
            }
        }
        const allowDynamicLimitFromBEFlag = await allowDynamicLimitFromBE();
        instrumentTrack("SET_MF_LIMIT_AMOUNT_PAGE_VIEWED");
        const pledgeLimitResponse = authCAS
            ? { data: authCAS }
            : await fetchPledgeLimitRepo().then((response) => ({
                data: response,
            }));
        const stepResponseObject = pledgeLimitResponse.data.stepResponseObject;
        const creditAmount = await sharedPropsService.getCreditLimit();
        const updateAvailableCASMapSharedProps = await sharedPropsService.getAvailableCASMap();
        const updateAvailableCASMap = updateAvailableCASMapSharedProps;
        const user = await sharedPropsService.getUser();
        const lenderId = user?.linkedApplications[0]?.lenderAccountId;
        if (creditAmount >= 0) {
        }
        else {
            stepResponseObject.availableCAS.map((item, index) => {
                let key = `${item.isinNo}-${item.folioNo}`;
                item.pledgedUnits = item.totalAvailableUnits;
                updateAvailableCASMap[key] = item;
            });
        }
        await SharedPropsService.setAvailableCASMap(updateAvailableCASMap);
        const portValue = getDesiredValue(stepResponseObject.availableCAS, stepResponseObject.isinNAVMap);
        await SharedPropsService.setDesiredPortfolio(portValue);
        const isEnhancedLimit = await AsyncStorage.getItem("application_id") !== null;
        const minimumEligibleLimit = await SharedPropsService.getMinimumEligibleLimitData();
        //@ts-ignore
        const isEligible = minimumEligibleLimit?.isEligible;
        //@ts-ignore
        const minimumAmount = minimumEligibleLimit?.amount;
        const isNotEligible = allowDynamicLimitFromBEFlag
            ? (typeof totalCreditAmount === 'number' && totalCreditAmount < minimumAmount)
            : (typeof totalCreditAmount === 'number' && (isEnhancedLimit ? (totalCreditAmount < MIN_LIMIT.ENHANCE_LIMIT) : (totalCreditAmount < getMinAllowedAmountBasedOnLender(lenderId))));
        return Promise.resolve(template(stepResponseObject.availableCreditAmount, stepResponseObject, updateAvailableCASMap, portValue, lenderId, isEnhancedLimit, totalCreditAmount, isFromMyFi, minimumAmount, isEligible, allowDynamicLimitFromBEFlag, isNotEligible, isFromMFCentral));
    },
    actions: {
        [ACTION.ON_CHANGE_SLIDER]: OnChangeSlider,
        [ACTION.ON_CHANGE_COMPLETE_SLIDER]: OnChangeCompleteSlider,
        [ACTION.GO_BACK]: goBack,
        [ACTION.GO_CONFIRM_PLEDGE]: goConfirmPledge,
        [ACTION.EDIT_PORTFOLIO]: goToEditPortFolio,
        [ACTION.EDIT_LIMIT]: editSliderAmount,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.CLOSE_POPUP]: closePopup,
    },
};
